import React from 'react';
import { Flex, Box } from '@atlaskit/primitives';
import Button from '@atlaskit/button';
import Lozenge from '@atlaskit/lozenge';

export type ShowMoreLessProps = {
  items: JSX.Element[];
  itemsToShow?: number;
  showMoreText?: string;
  showLessText?: string;
};

export const ShowMoreLess = ({
  items,
  itemsToShow,
  showMoreText = 'Show more',
  showLessText = 'Show less',
}: ShowMoreLessProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false);
  const visibleItems = !itemsToShow || isExpanded ? items : items.slice(0, itemsToShow);

  const toggleExpanded = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div data-test-id="show-more-less-container">
      {visibleItems}
      {itemsToShow && items.length > itemsToShow && (
        <Box paddingBlockStart="space.050">
          <Flex alignItems="center" gap="space.050">
            {!isExpanded && <Lozenge>+{items.length - itemsToShow}</Lozenge>}
            <Button appearance="link" onClick={toggleExpanded} spacing="none" testId="show-more-button">
              {isExpanded ? showLessText : showMoreText}
            </Button>
          </Flex>
        </Box>
      )}
    </div>
  );
};
